import { useState, useEffect } from 'react';
import _get from 'lodash/get';

import { EMPTY_OBJECT, KEY_VALUE_LAYOUT } from 'commons-ui';
import { VIEW_FIELD_KEYS } from './constants';
import useService from './useService';
import { getKeyConfig } from './getKeyConfig';

const useKycDetails = () => {
	const [showLoader, setShowLoader] = useState(true);
	const [kycData, setKycData] = useState<Object>(EMPTY_OBJECT);

	const { getKycDetails } = useService();

	useEffect(() => {
		const getKycStatus: () => void = async () => {
			try {
				setShowLoader(true);
				const data = await getKycDetails();
				setShowLoader(false);

				setKycData(data);
			} catch (error: any) {
				setShowLoader(false);
			}
		};
		getKycStatus();
	}, []);

	return {
		keyConfig: _get(getKeyConfig({ kycStatus: _get(kycData, VIEW_FIELD_KEYS.KYC_STATUS) }), 'keyConfig'),
		keyValueLayout: KEY_VALUE_LAYOUT.VERTICAL,
		showLoader,
		kycId: _get(kycData, VIEW_FIELD_KEYS.KYC_ID),
		manualVerificationRequired: _get(kycData, VIEW_FIELD_KEYS.MANUAL_VERIFICATION_REQ),
		kycStatus: _get(kycData, VIEW_FIELD_KEYS.KYC_STATUS)
	};
};

export default useKycDetails;
